import { MutationTree } from 'vuex';
import { AttendeeFixedCostState } from './types';
import { AttendeeFixedCost } from '@/shared/model/attendeeFixedCost';

export const mutations: MutationTree<AttendeeFixedCostState> = {
  setAttendeeFixedCosts(state, payload: AttendeeFixedCost[]) {
    state.attendeeFixedCosts = payload;
  },
};
